<template>
  <div class="relative w-full">
    <div
      v-if="placeholder.length"
      class="w-full pb-1 truncate text-grey-darker font-semibold"
    >
      <label :for="name">{{ placeholder }}</label>
      <span v-if="required" class="text-red">*</span>
    </div>

    <div
      :class="[
        border,
        {
          'cursor-pointer': !disabled && !loading,
          'opacity-75': loading,
        },
      ]"
      class="border rounded-lg flex items-center justify-between px-3 h-12 bg-white"
      @click="toggleDropdown"
    >
      <span class="truncate text-sm">
        {{ loading ? "Loading..." : selectedLabel || select_placeholder }}
      </span>

      <div class="flex items-center">
        <span
          v-if="loading"
          class="animate-spin inline-block w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full"
        ></span>

        <img
          v-else
          src="@/assets/icons/papsi_dropdown.svg"
          class="w-icon h-icon transition-transform"
          :class="{ 'rotate-180': is_open }"
        />
      </div>
    </div>

    <div
      v-if="is_open && !loading"
      class="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg overflow-y-auto"
      style="max-height: 250px"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="px-3 h-12 flex items-center hover:bg-gray-100 cursor-pointer"
        @click="selectOption(option)"
      >
        {{ option.label }}
      </div>
    </div>

    <span v-if="error_message" class="text-xs text-error">
      {{ error_message }}
    </span>
  </div>
</template>

<script>
import mixin from "@/mixin";

export default {
  name: "v-combobox",
  mixins: [mixin],
  props: {
    name: String,
    placeholder: String,
    select_placeholder: {
      type: String,
      default: "Select an option",
    },
    modelValue: [String, Number],
    options: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    required: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      val: "",
      is_open: false,
      border: "border-grey",
      error_message: null,
    };
  },

  computed: {
    selectedLabel() {
      const option = this.options.find((o) => o.value === this.val);

      return option ? option.label : "";
    },
  },

  mounted() {
    this.val = this.modelValue;
    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    toggleDropdown() {
      if (this.disabled || this.loading) return;
      this.is_open = !this.is_open;
    },

    selectOption(option) {
      this.val = option.value;
      this.is_open = false;

      this.$emit("update:modelValue", option.value);
      this.$emit("change", option.value);
      this.$emit("input", option.value);
    },

    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.is_open = false;
      }
    },
  },

  watch: {
    modelValue(value) {
      this.val = value;
    },
  },
};
</script>

<style scoped>
.papsi-icon-mt {
  margin-top: 7px;
}

.papsi-txt-lh {
  line-height: 40px;
}
</style>
